import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslationModule } from 'angular-l10n';
import { PayloadComponent } from './../payload/payload.component';
import { AutoFocusDirective } from './../auto-focus.directive';
import { ApiService } from 'services/api.service';
import { FlowEngineComponent } from './flow-engine.component';
import { FlowService } from 'services/flow.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExpressionEditorComponent } from "../expression-editor/expression-editor.component";
import { FallbackTranslationProvider } from "providers/fallbacktranslation.provider";
import { MessageboxComponent } from "app/messagebox/messagebox.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    TranslationModule.forRoot({translationProvider: FallbackTranslationProvider})
  ],
  entryComponents:[MessageboxComponent],
  providers: [FlowService, ApiService],
  exports: [FlowEngineComponent,ExpressionEditorComponent,PayloadComponent],
  declarations: [FlowEngineComponent,ExpressionEditorComponent,AutoFocusDirective,PayloadComponent]
})
export class FlowEngineModule { }



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/flow-engine/flow-engine.module.ts